import { useQuery } from '@tanstack/react-query';
import { TransportersApi } from 'api';

/**
 * Custom React Query hook to fetch carrier data by id
 *
 * @param {number} id
 * @param {{onError?: (error: Error) => void}} options
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useGetTransporter(id, { onError } = {}) {
  return useQuery({
    queryKey: ['transporter', id],
    queryFn: () =>
      TransportersApi.detail(id)
        .then((res) => res.data)
        .catch((error) => {
          typeof onError === 'function' && onError(error);
        }),
  });
}
